import { render, staticRenderFns } from "./Electronics.vue?vue&type=template&id=dc2f262a&"
import script from "./Electronics.vue?vue&type=script&lang=js&"
export * from "./Electronics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports